module.exports = __webpack_public_path__ + "img/lp-adn.9f80f95a.svg";